<template>
    <div class="ConstantList pa-3">
        <v-text-field
            outlined
            dense
            hide-details
            v-model="searchKey"
            class="mb-3"
            :label="this.$f.tc('search')"
        ></v-text-field>
        <FCIDataTable :items="filterItems" :headers="headers">
            <template v-slot:action="props">
                <v-btn icon class="mr-3">
                    <v-icon @click="editItem(props.item, props.index)">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon>
                    <v-icon @click="deleteItem(props.item, props.index)">mdi-delete</v-icon>
                </v-btn>
            </template>
        </FCIDataTable>
        <v-btn color="primary" class="mt-3" @click="addItem">{{ $f.tc('add') }}</v-btn>
        <ConstantEditor ref="ItemEditor"></ConstantEditor>
    </div>
</template>

<script>
import ListViewMixin from '@/modules/fptai/mixins/ListViewMixin'
import { ConstantService } from '@/services/bot.service'
import ConstantEditor from '@/views/Scenario/Setting/ConstantEditor'

export default {
    name: 'ConstantList',
    components: { ConstantEditor },
    mixins: [ListViewMixin],
    computed: {
        headers () {
            return [
                {
                    text: this.$f.tc('variable'),
                    value: 'name'
                },
                {
                    text: this.$f.tc('value'),
                    value: 'value'
                },
                {
                    text: this.$f.tc('action'),
                    value: 'action',
                    type: 'custom'
                }
            ]
        }
    },
    methods: {
        refresh () {
            ConstantService.search(this.$route.params.botCode).then(result => {
                this.items = result.data
            })
        },
        addItem () {
            this.$refs.ItemEditor.open(null).then(item => {
                ConstantService.create(this.$route.params.botCode, {
                    name: item.name,
                    value: item.value,
                    builtin: 0,
                    data_type_type: 'text',
                    entity: '',
                    memory_type: 1
                }).then(result => {
                    this.items.push(result.data)
                })
            })
        },
        editItem (item, index) {
            this.$refs.ItemEditor.open(item).then(newItem => {
                if (newItem.value !== item.value) {
                    ConstantService.update(this.$route.params.botCode, item.id, {
                        name: newItem.name,
                        value: newItem.value,
                        builtin: 0,
                        data_type_type: 'text',
                        entity: '',
                        memory_type: 1
                    }).then(result => {
                        this.items.splice(index, 1, result.data)
                    })
                }
            })
        },
        onDeleteItem (item, index) {
            ConstantService.delete(this.$route.params.botCode, item.id).then(() => {
                this.items.splice(index, 1)
            })
        }
    }
}
</script>

<style scoped lang="scss">
.ConstantList::v-deep table {
    table-layout: fixed;

    tr th {
        &:nth-child(3) {
            width: 180px;
        }
    }
}
</style>
